import React, {useState} from "react";
import getShort from "../../Components/getShort/getShort";
import swal from "sweetalert";
import axios from "axios";
import {Multipartheader} from "../../Components/Url/ApiUrl";
import {useTranslation} from "react-i18next";
const ComplaintView = ({ show, handleClose, data, handleViewFile, handleFetch}) => {
    const {t} = useTranslation();
    const [dalolatnoma, setDalolatnoma] = useState(null)

    const handleSubmit = async () => {

        if (!dalolatnoma) {
            await swal(t('warning'), t('please_upload_dalolatnoma'), "warning");
            return;
        }

        const formData = new FormData();
        formData.append("dalolatnoma", dalolatnoma);
        formData.append("id", data.id);

        try {
            const res = await axios.post(
                process.env.REACT_APP_API_ENDPOINT + "/company/complaints",
                formData,
                { headers: Multipartheader }
            );

            if (!res.data?.success) {
                let firstError = t('saving_error');
                const message = res.data?.message;
                if (message && typeof message === "object") {
                    const firstKey = Object.keys(message)[0];
                    if (firstKey && Array.isArray(message[firstKey])) {
                        firstError = message[firstKey][0];
                    }
                } else {
                    firstError = message;
                }

                await swal(t('error'), firstError, "error");
                return;
            }

            await swal(t('saved'), t('area_add_success'), "success");
            handleFetch();
        } catch (err) {
            swal(t('error'), err.message || t('translation:unknown_error'), "error");
        }
    };



    if(!data){
        return <div>{t('translation:loading')}</div>
    }
    return (
        <div
            className={`modal fade ${show ? "show" : ""}`}
            id="editModal"
            tabIndex="-1"
            aria-labelledby="editModalLabel"
            style={{ display: show ? "block" : "none" , background: "rgba(0, 0, 0, 0.65)", zIndex: 1000}}
        >
            <div className="modal-dialog" style={{minWidth:'1000px'}}>
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="editModalLabel">
                            {t('complaint_from_farmer')}
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={handleClose}
                        ></button>
                    </div>
                    <div className="modal-body">
                        <div>
                            <p><b>{t('farmer')}</b></p>
                            <p>{data.farmer_name || ''}</p>
                        </div>
                        <hr/>
                        <div>
                            <p><b>{t('sended')}</b></p>
                            <p>{data.created_at || ''}</p>
                        </div>
                        <hr/>
                        <div>
                            <p><b>{t('complaint_context')}</b></p>
                            <p>{data.body || ''}</p>
                        </div>
                    </div>
                    <div className="modal-footer justify-content-between">
                        {data.file_name ? (
                            <button className="btn btn-link p-0"
                                    onClick={() => handleViewFile(data.file_name)}>
                                {t('dalolatnoma')} <i className="bi bi-file-pdf"></i>
                            </button>
                        ) : (
                            <small>{t('dalolatnoma_not_attached')}</small>
                        )}
                        <>
                            <input
                                id="dalolatnomaInput"
                                type="file"
                                accept="application/pdf"
                                style={{display:"none"}}
                                onChange={e=>{
                                    setDalolatnoma(e.target.files[0])
                                }
                                }
                            />
                            <div>

                                &nbsp;&nbsp;&nbsp;
                                <button type="button" className="btn btn-outline-primary"
                                        onClick={() => document.getElementById("dalolatnomaInput").click()}>
                                    <i className="bi bi-file-pdf"></i> {data.file_name?t('attach_other_dalolatnoma'):t('attach_dalolatnoma')}
                                </button>
                                <span className="px-3">
                                        {
                                            dalolatnoma ? getShort(dalolatnoma.name) : ''
                                        }
                                    </span>
                                {
                                    dalolatnoma?
                                        <button className="btn btn-success" onClick={handleSubmit}>{t('save')}</button>
                                        :null
                                }
                            </div>
                        </>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ComplaintView;


